module.exports = __webpack_public_path__ + "img/nav-design-diamondscolliers.b3e13f5.webp";